import { render, staticRenderFns } from "./Polaroid.vue?vue&type=template&id=73f4fa22&scoped=true&"
var script = {}
import style0 from "./Polaroid.vue?vue&type=style&index=0&id=73f4fa22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f4fa22",
  null
  
)

export default component.exports